import { createSlice } from "@reduxjs/toolkit";
import { getProgram } from "../actions";

interface Program {
    _id: string;
    programName: string;
    programType: string;
    programCode: string;
    primaryContacts: {
        name: string;
        primaryPhone: string;
        secondaryPhone: string
    }
    secondaryContacts: {
        secName: string;
        secPrimaryPhone: string;
        secSecondaryPhone: string
    }
    capacity: number;
    siteName: string;
    programID: number;
    individualsAdded: string;
    programCostCenterNumber: number;
    createDate: string;
    providerCode: string;
    providerName: string;
}

interface ProgramState {
    program: Program[] | any;
    isLoading: boolean
}

const initialState: ProgramState = {
    program: [],
    isLoading: false
}

export const programInitialSlice = createSlice({
    name: 'program',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(getProgram.fulfilled, (state, action: any) => {
            state.program = action.payload.data
            state.isLoading = false
        })
            .addCase(getProgram.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(getProgram.rejected, (state, action) => {
                state.isLoading = false
            })
    }
})

export default programInitialSlice.reducer